<div
    [id]="id"
    class="agpr-agentFilter"
>
    <div class="topicHeader">
        <agpr-checkbox
            [id]="id + '_selectAllAgents'"
            label="Social.intelligence.themeManagement.agents"
            [binary]="true"
            [(ngModel)]="selectAll"
            hiddenLabel="selectAll"
            (ngModelChange)="toggleSelectAll()"
        ></agpr-checkbox>
        <agpr-button
            [id]="id + '_createSocialTopicButton'"
            [style]="buttonTypes.icon"
            [icon]="'fa-regular fa-duotone fa-square-plus'"
            [disabled]="currentTheme?.subscriptionIds?.length >= AGENT_MAX"
            [tooltip]="
                currentTheme?.subscriptionIds?.length >= AGENT_MAX
                        ? maxReachedTooltip
                        : 'Social.intelligence.themeManagement.themeCard.addAgent.createAgent'
            "
            (click)="createNewAgent.emit()"
        ></agpr-button>
    </div>

    <agpr-scroll-panel class="agpr-agentFilter-scrollPanel">
        <h3 class="u-srOnly">{{ 'Monitoring.filtersLocalization.agents' | localize }}</h3>
        <ul
            class="topicList"
            [attr.aria-label]="'Social.intelligence.themeManagement.agent' | localize"
        >
            @for (agent of themeAgents; track agent.id; let i = $index) {
                <li class="topicListItem">
                    <agpr-checkbox
                        [id]="i + '_agentFilter_checkbox'"
                        [label]="agent.name"
                        [binary]="true"
                        [ngClass]="{'agpr-agentFilterLabel--paused': !agentActiveness[agent.id]}"
                        [(ngModel)]="value[agent.id]"
                        (ngModelChange)="update()"
                        [pTooltip]="agent.name + '\nStatus: ' +
                            ((agentActiveness[agent.id] ? 'Social.status.Active' : 'Social.status.Paused') | localize)
                        "
                        tooltipPosition="bottom"
                        [hiddenLabel]="' status:' + ((agentActiveness[agent.id] ? 'Social.status.Active' : 'Social.status.Paused') | localize)"
                    ></agpr-checkbox>
                    <agpr-button
                        [id]="id + '_agent_' + i + '_isolateButton'"
                        [style]="buttonTypes.icon"
                        icon="fa-regular fa-duotone fa-arrows-to-circle"
                        (click)="isolate(agent.id)"
                        tooltip="Social.intelligence.theme.isolate"
                        tooltipPosition="bottom"
                    ></agpr-button>
                    <agpr-button
                        [id]="id + '_agent_' + i + '_editButton'"
                        [style]="buttonTypes.icon"
                        icon="fa-regular fa-duotone fa-pen"
                        (click)="editAgent(agent)"
                        tooltip="Social.intelligence.theme.edit"
                        tooltipPosition="bottom"
                    ></agpr-button>
                </li>
            }
        </ul>
    </agpr-scroll-panel>
</div>
